export const NO_SDK_ERROR = 'NO_SDK_ERROR';
export const SDK_WINDOW_KEY = '@combateafraude/identity-sdk';
export const SDK_URL_WINDOW_KEY = '@combateafraude/identity-sdk-url';
export const PROMISE_WINDOW_KEY = '@combateafraude/identity-sdk-promise';
